import React, { useEffect } from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from "../../components/Breadcrumb";
import { useParams } from "react-router";
import StoryService from "../../services/story.service";


const StoryDetail = () => {
  const [storyDetail,setStoryDetail]=React.useState({});
  const params=useParams();
  console.log("param",params);

    const relatedStories=[
        {poster:"../img/story/poster-1.png"},
        {poster:"../img/story/poster-2.png"},
        {poster:"../img/story/poster-1.png"},
    ];

    React.useEffect(()=>{
      StoryService.detail(params.slug)
      .then(res=>setStoryDetail(res?.data))
      .catch(err=>console.log(err));
    },[]);

  return (
    <>
      <Header />
      <Breadcrumb pageTitle={"Success Story"} />
      <section className="container py-4">
        <div>
          <h2 className="display-4 text-center text-black fw-bold my-3">
            Success <strong style={{color:"#FE7743"}} className=" fw-semibold">Story</strong>
          </h2>
          <div className="fs-5 m-auto my-4 col-md-11 text-center" dangerouslySetInnerHTML={{__html:storyDetail?.description}}>
          </div>
        </div>

        {/* <div className="position-relative py-4">
         <img src={storyDetail?.featureImgUrl} className=" w-100"/>
        </div> */}

        {/* <div className="position-relative py-4">
          <video
            className="shadow border-3 border-white img-fluid"
            poster={"./img/story/poster-detail.png"}
          >
            <source src="/" />
          </video>
          <button className="border-0 outline-none bg-transparent position-absolute top-50 start-50 translate-middle">
            <img src="./img/story/play.svg" width={60} height={60} />
          </button>
        </div> */}
        
        {/* <div className="pb-md-4">
            <h3 className="text-black fw-bold">Related Posts</h3>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                {
                    relatedStories?.map((item,idx)=>(
                        <div key={idx} className="col position-relative">
                        <video
                          className="shadow border-3 border-white p-2 img-fluid"
                          width={400}
                          height={322}
                          poster={item?.poster}
                        >
                          <source src="/" />
                        </video>
                        <button className="border-0 outline-none bg-transparent position-absolute top-50 start-50 translate-middle">
                          <img src="./img/story/play.svg" className="img-fluid" width={60} height={60} />
                        </button>
                        <img src={item?.poster}/>
                      </div>

                    ))
                }
            </div>
            {

            }

        </div> */}
      </section>
      <div>
      <FooterTwo />
      </div>

    </>
  );
};

export default StoryDetail;
